import { z } from "zod";
export const FigmaNodeStructureStateV2 = z.enum([
    "InProgress",
    "Success",
    "Failed",
]);
export const FigmaNodeStructureV2 = z.object({
    id: z.string(),
    designSystemId: z.string(),
    sourceId: z.string(),
    storagePath: z.string().optional(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    lastUpdateStartedAt: z.coerce.date().optional(),
    importState: FigmaNodeStructureStateV2,
    error: z.string().optional(),
    chunkSize: z.number().optional(),
    // TODO Artem: remove after migration
    isFromLegacyStorage: z.boolean(),
});
